import React from "react";
import { Box, styled, Typography, useTheme } from "@mui/material";
import { CenteredSiteBlock } from "../../routes/Home";
import { useIsMobile } from "../../hooks/responsive";
import Header from "./Header";
import PraticiansPodcasts from "./PraticiansPodcasts";
import weirdBackground from "../../resources/images/svg/home/zoomIcon.svg";

const Container = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    minHeight: "100px",
    backgroundColor: theme.palette.blackPro,
    position: "relative",
  };
});

const PodcastsSection = ({proInfos, handleScrollProfile}) => {
  const isMobile = useIsMobile();

  return (
    <Container className={"podcasts-section"}>
      <Box
        sx={{
          position: "absolute",
          left: 0,
          right: 0,
          height: "350px",
          top: 0,
          background: "linear-gradient(0deg, #0D0034 0.3%, #9A45F4 100%)",
          opacity: 0.5,
        }}
      />
      <CenteredSiteBlock
        sx={{
          background: `url(${weirdBackground})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "bottom",
          position: "relative",
          marginTop: (theme) => theme.spacing(isMobile ? 5 : 2),
          marginBottom: (theme) => theme.spacing(isMobile ? 5 : 10),
          display: "flex",
          flexDirection: "column",
          paddingLeft: "20px",
          paddingRight: "20px",
        }}
      >
        <Header proInfo={proInfos} handleScrollProfile={handleScrollProfile} />
        <PraticiansPodcasts />
      </CenteredSiteBlock>
    </Container>
  );
};

export default PodcastsSection;
